import { Vector2 } from "three";

export const addEase = (pos: number, to: number, easing: number): number => {
  return pos + (to - pos) / easing;
};

export const addEase2 = (pos: Vector2, to: Vector2, easing: number): void => {
  pos.x += (to.x - pos.x) / easing;
  pos.y += (to.y - pos.y) / easing;
};
